import * as React from 'react';
import { Alert } from 'reactstrap';
import "./ErrorMessage.css";

interface ErrorMessageProps {
    errors: string[];
}

export default class ErrorMessage extends React.Component<ErrorMessageProps> {
        
    public render() {
        if( this.props.errors.length === 0 ) { return null; }

        return (
            <>                  
                { this.props.errors.map(this.renderErrorMessage) }                
            </>
        );
    }

    private renderErrorMessage(error: string, index: number) {
        return (
            <Alert color="danger">{error}</Alert>                
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/errorMessage/ErrorMessage.tsx